"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgoraCameraPreview = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _CameraPreview = require("../../CameraPreview/CameraPreview.styled");
var _Join = require("../../../constants/Join");
var _BrandContext = _interopRequireDefault(require("../../../contexts/BrandContext"));
var _propTypes = require("prop-types");
var _StudioLogger = require("@studio/logger/StudioLogger");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
var LOG = new _StudioLogger.StudioLogger('agora-camera-preview');

/**
 * Agora camera preview component that displays the user's camera feed with name and description.
 * Shows appropriate error messages when camera access is unavailable.
 *
 * @component
 * @param {Object} props - Component props
 * @param {Object} props.videoInputDevice - Selected video input
 * @param {string} props.presenterTitle - User's name/title to display in the camera preview
 * @param {string} props.presenterDescription - User's description/role to display in the camera preview
 * @param {string} props.checkStatus - Current status of the device check process
 * @returns {React.Element} Rendered component
 */
var AgoraCameraPreview = exports.AgoraCameraPreview = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var videoInputDevice = _ref.videoInputDevice,
    presenterTitle = _ref.presenterTitle,
    presenterDescription = _ref.presenterDescription,
    checkStatus = _ref.checkStatus;
  var videoRef = (0, _react.useRef)(null);
  var brandContext = (0, _react.useContext)(_BrandContext["default"]) || {};
  var browserBlock = checkStatus === _Join.JOIN_PAGE_STATUS.BROWSER_BLOCK;
  var hasPresenterTitle = presenterTitle.trim() !== '';
  var hasPresenterDescription = presenterDescription.trim() !== '';
  var showNameCard = hasPresenterTitle || hasPresenterDescription;
  var virtualBackground = videoInputDevice.virtualBackground,
    device = videoInputDevice.device;
  (0, _react.useEffect)(function () {
    var videoElement = videoRef.current;
    if (!videoElement || !videoInputDevice.videoTrack) return;
    var startVideo = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (videoInputDevice.videoTrack.enabled) {
                _context.next = 1;
                break;
              }
              _context.next = 1;
              return videoInputDevice.videoTrack.setEnabled(true);
            case 1:
              videoInputDevice.videoTrack.play(videoElement);
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              LOG.error('Failed to start video:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function startVideo() {
        return _ref2.apply(this, arguments);
      };
    }();
    startVideo();
    return function () {
      LOG.info('Cleaning up video stream');
      if (videoElement) {
        videoElement.srcObject = null;
      }
    };
  }, [videoInputDevice, virtualBackground, device]);
  var noInput = !videoInputDevice.videoTrack;
  var hasError = noInput || browserBlock;
  var errorMessage = browserBlock ? 'Allow your browser to access your devices to continue' : 'Select a working camera';
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: brandContext
  }, /*#__PURE__*/_react["default"].createElement(_CameraPreview.VideoWrapper, null, hasError ? /*#__PURE__*/_react["default"].createElement(_CameraPreview.StyledSection, {
    "data-testid": "error-element"
  }, /*#__PURE__*/_react["default"].createElement("span", null, errorMessage)) : /*#__PURE__*/_react["default"].createElement(_CameraPreview.StyledVideo, {
    "aria-label": "Camera Preview - title: ".concat(presenterTitle, " description: ").concat(presenterDescription),
    "data-testid": "video-element",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transform: 'scaleX(-1)'
    },
    ref: videoRef,
    id: "camera-preview-video",
    muted: true,
    playsInline: true,
    autoPlay: true
  }), showNameCard && /*#__PURE__*/_react["default"].createElement(_CameraPreview.StyledNameCard, {
    "data-testid": "name-card",
    hasDescription: hasPresenterDescription
  }, /*#__PURE__*/_react["default"].createElement(_CameraPreview.StyledName, {
    className: "h6"
  }, presenterTitle), /*#__PURE__*/_react["default"].createElement(_CameraPreview.StyledDescription, null, presenterDescription))));
});
AgoraCameraPreview.propTypes = {
  videoInputDevice: (0, _propTypes.shape)({
    device: _propTypes.string,
    videoTrack: _propTypes.object
  }),
  presenterTitle: _propTypes.string.isRequired,
  presenterDescription: _propTypes.string.isRequired,
  checkStatus: _propTypes.string.isRequired
};